import React, {useState} from 'react'

interface InputFieldProps {
    id: string
    name: string
    type: string
    value: string
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => void
    error?: string
    label: string
    autoFocus?: boolean
    autoComplete?: string
    placeholder?: string
    hint?: string
}

export const InputField: React.FC<InputFieldProps> = ({
    id, name, type, value, onChange, error, label, autoFocus = false,
    autoComplete, placeholder, hint,
}) => {
    const [visible, setVisible] = useState(false)
    const isPassword = type === 'password'
    const descriptionId = error ? `${id}-error` : hint ? `${id}-hint` : undefined

    return (
        <div className="form-group">
            <label htmlFor={id}>{label}</label>
            <div className={`auth-input-wrap${isPassword ? ' has-toggle' : ''}`}>
                <input
                    type={isPassword && visible ? 'text' : type}
                    id={id}
                    name={name}
                    value={value}
                    onChange={onChange}
                    className={error ? 'error' : ''}
                    autoFocus={autoFocus}
                    autoComplete={autoComplete}
                    placeholder={placeholder}
                    aria-invalid={!!error}
                    aria-describedby={descriptionId}
                    autoCapitalize={type === 'email' ? 'none' : undefined}
                    spellCheck={false}
                />
                {isPassword && (
                    <button type="button" className="auth-password-toggle"
                            aria-label={`${visible ? 'Hide' : 'Show'} ${label.toLowerCase()}`}
                            aria-controls={id} aria-pressed={visible}
                            onClick={() => setVisible(!visible)}>
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" aria-hidden="true">
                            <path d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7S2 12 2 12Z"/>
                            <circle cx="12" cy="12" r="3"/>
                            {visible && <path d="m3 3 18 18"/>}
                        </svg>
                    </button>
                )}
            </div>
            {error ? <span id={`${id}-error`} className="error-message">{error}</span>
                : hint && <span id={`${id}-hint`} className="auth-field-hint">{hint}</span>}
        </div>
    )
}
